import React from 'react';

const ImgTracks = ({ tracks }) => {
  if (!tracks) return null;

  return (
    <div className="cardd">
      <div className="card-headingg">
        <h1>Top Tracks</h1>
      </div>
      <div className="card-contentt">
        <ol>
          {tracks.slice(0, 5).map(track => (
            <li key={track.name}>{track.name}</li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default ImgTracks;
